import { IconEnums } from "../icon";

export const BannerTags = {
    AnnouncementBanner: "atlantis-announcement-banner",
    CookieBanner: "atlantis-cookie-banner"
};

class BannerButtonClickEvent extends Event {
  static EVENT_NAME = "atlantis-banner-button-click";
  constructor() {
    super(BannerButtonClickEvent.EVENT_NAME, { bubbles: true, composed: true });
  }
}

class CookieSettingsButtonClickEvent extends Event {
  static EVENT_NAME = "atlantis-cookie-settings-button-click";
  constructor() {
    super(CookieSettingsButtonClickEvent.EVENT_NAME, {
      bubbles: true,
      composed: true,
    });
  }
}

class CookieButtonClickEvent extends Event {
  static EVENT_NAME = "atlantis-cookie-button-click";
  constructor() {
    super(CookieButtonClickEvent.EVENT_NAME, { bubbles: true, composed: true });
  }
}

export const BannerEvents = {
    BannerButtonClickEvent,
    CookieSettingsButtonClickEvent,
    CookieButtonClickEvent
} as const;

export interface AtlAnnouncementBannerProps {
  bannerTitle?: string;
  showIcon?: boolean;
  iconName?: string;
  iconSize?: IconEnums.IconSizes;
  showCtaButton?: boolean;
  ctaButtonText?: string;
}

export interface AtlCookieBannerProps {
  bannerTitle?: string;
  showSettingsButton?: boolean;
  bannerType?: CookieBannerTypes;
  buttonLabel?: string;
}

export enum CookieBannerTypes {
  Inline = "Inline",
  PositionFixed = "PositionFixed",
}

export const BannerEnums = {
   CookieBannerTypes
} as const;